export default "__VITE_ASSET__BTg62Gpk__"